import { render, staticRenderFns } from "./VehicleInfosModal.vue?vue&type=template&id=70de43fc&scoped=true&"
import script from "./VehicleInfosModal.vue?vue&type=script&lang=js&"
export * from "./VehicleInfosModal.vue?vue&type=script&lang=js&"
import style0 from "./VehicleInfosModal.vue?vue&type=style&index=0&id=70de43fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70de43fc",
  null
  
)

export default component.exports